<template>
  <v-card>
    <v-toolbar flat color="#fff">
      <template v-if="$auth.tenant !== 'alliance-retail-group'">
      <v-col cols="3" class="pl-0" style="height:64px;">
        <v-text-field
          label="Filter items"
          prepend-inner-icon="mdi-filter-outline"
          outlined
          dense
          background-color="#fff"
          v-model="filter"
          clearable>
        </v-text-field>
      </v-col>
      </template>
      <template v-if="$auth.tenant === 'alliance-retail-group'">
      <v-col md="2" class="my-2 d-flex align-center">
        <v-icon
            v-show="filterSearch.key || filterSearch.value"
            small
            class="mr-4"
            @click="clearFilter()">
            $delete
        </v-icon>
        <v-select 
          placeholder="Search By" 
          :items="searchParams"
          item-text="description" 
          return-object 
          dense 
          hide-details 
          :menu-props="{ closeOnClick: true, bottom: true, offsetY: true }" 
          v-model="filterSearch.key" 
        />
      </v-col>
      <v-col md="2" class="ml-1 my-2">
        <v-text-field
          v-if="!showSourceFilter"
          v-model="filterSearch.value"
          :disabled="filterSearch.key === null"
          @keydown.enter="promoItemSearch()"
          :placeholder="filterSearch.key ? `Search By ${filterSearch.key.description}` : 'Select Search Field'"
          outlined
          dense
          hide-details
          background-color="input">
        </v-text-field>
        <v-autocomplete
          v-if="showSourceFilter"
          v-model="filterSearch.value"
          ref="filterSources"
          label="Search By Source"
          item-text="name"
          item-value="id"
          item-color="action"
          :items="sourceSelections"
          hide-no-data
          clearable
          background-color="#fff"
          dense
          outlined
          hide-details="auto">
            <template v-slot:item="{ item, attrs: { disabled } }">
              <div style="width: 100%">
                <template>
                  <v-list-item class="ma-0 pa-0" :disabled="disabled">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ `${item.name} (${item.count} item${item.count === 1 ? '' : 's'})` }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
              </div>
            </template>
        </v-autocomplete>
      </v-col>
      <v-tooltip top>
        <template #activator="{ on: searchActivator }">
          <v-btn
            v-if="loading && $auth.tenant === 'alliance-retail-group'"
            height="40"
            depressed
            class="ml-1 mr-4 my-2"
            color="grey darken">
            <v-icon color="white">mdi-timer-sand</v-icon>
          </v-btn>
          <v-btn
            v-else
            v-on="searchActivator"
            class="ml-1 mr-4 my-2"
            color="primary"
            :disabled="filterSearch.value == null || filterSearch.value === ''"
            @click="promoItemSearch()">
            <v-icon class="white--text">mdi-magnify</v-icon>
          </v-btn>
        </template>
        <span>Search Items</span>
      </v-tooltip>
      <v-col v-if="items.length > 0" class="d-flex align-center">
        <span>Unique Items: {{ uniqueItemCount }}</span>
        <v-switch 
          v-if="disableActiveAllowance"
          v-model="forceActiveAllowance" 
          label="Fetch net unit cost stack"
          color="action"
          hide-details
          dense
          class="ml-10 my-auto"
          @change="initPromoItemList(searching)">
        </v-switch>
      </v-col>
      </template>
       <v-spacer></v-spacer>
       <div v-if="selectedItems.length > 0">
        <v-btn
          v-show="id && !readOnlyPromo"
          id="removeSelectedItemsButton"
          small
          color="red"
          class="white--text"
          @click="handleRemoveGroupConfirmDialog">
          <v-icon left dense small>mdi-trash-can-outline</v-icon>
          Remove Items
        </v-btn>
       </div>
       <div v-if="selectedItems.length > 0">
        <v-btn
          v-show="id && !readOnlyPromo"
          id="moveSelectedItemsButton"
          small
          color="primary"
          class="white--text ml-2"
          @click="showMoveItemsDialog = true">
          <v-icon left dense small>mdi-file-move-outline</v-icon>
          Move Items
        </v-btn>
       </div>
       <div v-if="selectedItems.length > 0">
        <v-btn
          v-show="id && !editIsDisabled"
          id="clearSelectedItemsButton"
          small
          class="ml-2"
          color='primary'
          dark
          @click="handleAllSelection(false)">
          Clear Selection
        </v-btn>
       </div>
       <div>
        <v-btn
          v-show="id && !editIsDisabled"
          id="selectAllItemsButton"
          small
          class="ml-2"
          color='primary'
          dark
          @click="handleAllSelection(true)">
          Select All
        </v-btn>
       </div>
       <div>
        <v-btn
          v-show="id && !editIsDisabled"
          id="newGroupButton"
          small
          class="ml-2"
          color='primary'
          dark
          @click="createNewGroup">
          New Group
        </v-btn>
       </div>
    </v-toolbar>
    <v-divider/>
    <v-data-table
      :height="tableSize"
      :loading="loading"
      :headers="headers"
      :items="filteredItems"
      ref="itemTableRef"
      :page.sync="page"
      :footer-props="{'items-per-page-options': [$auth.tenant !== 'alliance-retail-group' ? -1 : 200]}"
      :server-items-length="$auth.tenant === 'alliance-retail-group' ? serverItemsLength : filteredItems.length"
      color="#fff"
      loading-text="Loading... Please wait"
      :no-data-text="noDataText"
      fixed-header
      dense
      group-by="promo_item_group.id">

      <template v-slot:no-data>
        <v-alert
          v-if="!loading && items.length === 0"
          outlined
          text
          color="orange"
          class="mt-4">
          <template v-slot:default>
            <v-icon color="orange" class="mx-2 pb-1">
              mdi-alert-circle-outline
            </v-icon>
            <span v-if="itemGroupList.length === 0">
              Please create an item group to add items to this promotion.
            </span>
            <span v-else>
              Valid promotion requires at least one item added to promotion.
            </span>
          </template>
        </v-alert>
      </template>

       <template v-slot:[`header.variance`]="{ header }">
        <span v-if="promo.enforce_compliance">{{header.text}}</span>
      </template>

      <template v-slot:[`header.included`]>
        <v-btn @click="anyGroupsExpanded ? closeAll() : openAll()" dark small icon>
          <v-icon v-if="anyGroupsExpanded">mdi-chevron-up</v-icon>
          <v-icon v-else>mdi-chevron-down</v-icon>
        </v-btn>
      </template>

      <!-- Promo Item Group Header/Actions -->
      <template v-slot:[`group.header`]="{ group, items, headers, toggle, isOpen }">
        <td v-if="$auth.tenant === 'alliance-retail-group'" colspan="1">
          <v-btn @click="toggle" small icon :ref="group" :data-open="isOpen">
            <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
            <v-icon v-else>mdi-chevron-down</v-icon>
          </v-btn>
        </td>
        <td colspan="3">{{items[0].promo_item_group.name}}</td>
        <td :colspan="headers.length - 5">
          <em v-if="tenant !== 'alliance-retail-group'">
            {{ (groupOverridingPromo(items[0].promo_item_group)) ? 'Group values are overriding promo values': 'Values set by promo' }}
          </em>
        </td>
        <td colspan="2">
          <div class="group-actions-container">
            <v-btn
              icon
              small
              @click.stop="editGroup(group)">
              <v-icon v-if="!editIsDisabled">mdi-pencil-outline</v-icon>
              <v-tooltip v-else bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-on="on">mdi-information-variant-circle-outline</v-icon>
                </template>
                View Group Details
              </v-tooltip>
            </v-btn>
            <v-btn
              v-show="!editIsDisabled"
              icon
              small
              class="ml-1"
              @click.stop="deletedPromoItemGroup(group, items[0].promo_item_group.name)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </div>
        </td>
      </template>

      <!-- Edit Qty Per Case -->
      <template v-slot:[`item.item.qty_per_case`]="{ item }">
        <span v-if="!usePromoItemQtyPerCase">
          <span>
            {{ item.item.qty_per_case }}
          </span>
        </span>
        <v-menu
          v-else
          v-model="editingQtyPerCase"
          :close-on-content-click="false"
          :close-on-click="false"
          bottom
          right
          absolute
          nudge-top="-12px"
          nudge-left="16px"
          offset-y
          max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <div class="edit-menu-container"
              :style="!editIsDisabled ? 'cursor: pointer' : 'cursor: default'"
              v-on="!editIsDisabled ? on : null"
              v-bind="attrs"
              @click="!editIsDisabled ? openQtyPerCase(item) : null">
              <span>{{ item.promo_item_qty_per_case ? item.promo_item_qty_per_case : item.item.qty_per_case }}</span>
              <v-icon small v-if="!editIsDisabled">mdi-pencil</v-icon>
            </div>
          </template>
          <v-card class="pt-2 px-4" tile flat v-if="editItem && editItem.id === item.id">
            <div style="margin-top: 8px">
              <span class="subtitle-2">Edit {{$auth.tenant === 'alliance-retail-group' ? 'Pack' :'Qty Per Case'}}</span>
            </div>
            <v-text-field
              ref="qty_per_case"
              class="pt-0 mt-0"
              v-model="editItem.qty_per_case"
              :rules="[isValidQuantity, v => !(v < 0) || 'Cannot have negative value.']"
              autofocus
              type="number"
              hide-spin-buttons>
            </v-text-field>
            <v-card-actions class="pt-0 px-0">
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                @click="cancel">
                Cancel
              </v-btn>
              <v-btn
                small
                color="primary"
                :loading="savingItem"
                :disabled="savingItem || applyingAll || (editItem && editItem.qty_per_case < 0)"
                @click="save">
                Save
              </v-btn>
              <v-btn
                small
                color="accent"
                :loading="applyingAll"
                :disabled="applyingAll || savingItem || (editItem && editItem.qty_per_case < 0)"
                @click="openApplyAllDialog">
                Apply All
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>

      <template v-slot:[`item.included`]="{ item }">
        <v-simple-checkbox
          color="primary"
          v-model="item.selected"
          @input="itemSelected($event, item)"
          dense
          :ripple="false">
        </v-simple-checkbox>
      </template>

      <!-- Item ID -->
      <template v-slot:[`item.item.item_id`]="{ item }">
        <v-menu
            :nudge-right="50"
            :nudge-top="10"
            offset-y
            :open-on-hover="tenant === 'alliance-retail-group'"
            top>
            <template v-slot:activator="{ on }">
              <span v-on="on" :style="tenant === 'alliance-retail-group' ? 'cursor: pointer; color: #2589BD' : 'cursor: default'">
                {{ item.item.item_id }}
              </span>
            </template>
            <v-card class="rounded-lg">
              <v-list>
                <v-list-item class="pt-2" dense>
                  <p>
                    <b>Vendor Id: </b>{{ item.item.vendor_id }}
                  </p>
                </v-list-item>
                <v-list-item dense>
                  <p>
                    <b>Vendor Name: </b> {{ item.item.vendor_name }}
                  </p>
                </v-list-item>
                <v-list-item dense>
                  <p>
                    <b>Dept: </b> {{ item.item.department }}
                  </p>
                </v-list-item>
              </v-list>
            </v-card>
        </v-menu>
      </template>

      <!-- Discontinued Item Indicator -->
      <template v-slot:[`item.item.source_name`]="{ item }">
        <v-tooltip class="mx-auto" v-if="['DISCONTINUED ITEM', 'Inactive'].includes(item.item.status)" top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              color="warning"
              class="pb-1 ml-n8">
              <v-icon class="mx-auto">mdi-alert</v-icon>
            </v-btn>
          </template>
          <span>Item has been Discontinued</span>
        </v-tooltip>
          {{ item.item.source_name }}
      </template>

      <template v-slot:[`item.variance`]="{ item }">
        <span v-if="item && promo.enforce_compliance">
          {{ item.variance ? item.variance : '' }}
        </span>
      </template>
      <template v-slot:[`item.buy_item`]="{ item }">
        <span v-if="item && promo_type_fields.includes('buy_item')">
          {{ item.promo_item_group ? item.promo_item_group.buy_item : '' }}
        </span>
      </template>
      <template v-slot:[`item.get_item`]="{ item }">
        <span v-if="item && promo_type_fields.includes('get_item')">
          {{ item.promo_item_group ? item.promo_item_group.get_item : '' }}
        </span>
      </template>
      <template v-slot:[`item.qty`]="{ item }">
        <span v-if="item && promo_type_fields.includes('qty')">
          {{ item.promo_item_group ? item.promo_item_group.qty : '' }}
        </span>
      </template>

      <!-- Future Cost -->
      <template v-slot:[`item.cost`]="{ item }">
        <template v-if="checkVendorItemAccess">
          <span>{{ item.vendor_user_item ? item.item.cost : '-' }}</span>
        </template>

        <template v-else>
        <span v-if="!usePromoItemCost">
          <v-tooltip top v-if="(item.item.future_cost == item.item.cost) && (item.item.future_cost_date <= effectiveFutureCostDate)">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="primary--text font-weight-bold">
                {{ item.item.cost }}
              </span>
            </template>
            This item has a cost change on {{ $config.formatDate(item.item.future_cost_date) }} <br>
            The new cost of {{ item.item.cost }} is being used on this promotion
          </v-tooltip>
          <span v-else>
            {{ item.item.cost }}
          </span>
        </span>
        <!-- Edit Item Cost -->
        <v-menu
          v-else
          v-model="editingCost"
          :close-on-content-click="false"
          :close-on-click="false"
          bottom
          right
          absolute
          nudge-top="-12px"
          nudge-left="16px"
          offset-y
          max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <div
              class="edit-menu-container"
              :style="!editIsDisabled ? 'cursor: pointer' : 'cursor: default'"
              v-on="!editIsDisabled ? on : null"
              v-bind="attrs"
              @click="!editIsDisabled ? open(item, 'cost') : null">
              <v-tooltip top v-if="(item.item.future_cost == item.item.cost) && (item.item.future_cost_date <= effectiveFutureCostDate)">
                <template v-slot:activator="{ on }">
                  <span v-on="on" class="primary--text font-weight-bold">
                    {{ item.cost }}
                  </span>
                </template>
                This item has a cost change on {{ $config.formatDate(item.item.future_cost_date) }} <br>
                The new cost of {{ item.cost }} is being used on this promotion
              </v-tooltip>
              <span v-else>
                {{ item.cost }}
              </span>
              <v-icon small v-if="!editIsDisabled">mdi-pencil</v-icon>
            </div>
          </template>
          <v-card class="pt-2 px-4" tile flat v-if="editItem && editItem.id === item.id">
            <div style="margin-top: 8px">
              <span class="subtitle-2">Edit Item Cost</span>
            </div>
            <v-text-field
              ref="cost"
              class="pt-0 mt-0"
              v-model="editItem.cost"
              :rules="[isValidPrice, v => !(v < 0) || 'Cannot have negative value.']"
              autofocus
              type="number"
              hide-spin-buttons
              prefix="$">
            </v-text-field>
            <v-card-actions class="pt-0 px-0">
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                @click="cancel">
                Cancel
              </v-btn>
              <v-btn
                small
                color="primary"
                :loading="savingItem"
                :disabled="savingItem || applyingAll || (editItem && editItem.cost < 0)"
                @click="save">
                Save
              </v-btn>
              <v-btn
                small
                color="accent"
                :loading="applyingAll"
                :disabled="applyingAll || savingItem || (editItem && editItem.cost < 0)"
                @click="openApplyAllDialog">
                Apply All
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        </template>
      </template>

      <!-- Edit Retail Price -->
      <template v-slot:[`item.retail_price`]="{ item }">
        <template v-if="checkVendorItemAccess">
          <span>{{ item.vendor_user_item ? item.retail_price : '-' }}</span>
        </template>
        <template v-else-if="tenant === 'alliance-retail-group'">
          <span>{{ item.retail_price }}</span>
        </template>
        <template v-else>
        <v-menu
          v-model="editingRetailPrice"
          :close-on-content-click="false"
          :close-on-click="false"
          bottom
          right
          absolute
          nudge-top="-12px"
          nudge-left="16px"
          offset-y
          max-width="300px">
          <template v-slot:activator="{ on, attrs }">
            <div class="edit-menu-container"
              :style="!editIsDisabled ? 'cursor: pointer' : 'cursor: default'"
              v-on="!editIsDisabled ? on : null"
              v-bind="attrs"
              @click="!editIsDisabled ? open(item, 'retail_price') : null">
              <span>{{ item.retail_price }}</span>
              <v-icon small v-if="!editIsDisabled">mdi-pencil</v-icon>
            </div>
          </template>
          <v-card class="pt-2 px-4" tile flat v-if="editItem && editItem.id === item.id">
            <div style="margin-top: 8px">
              <span class="subtitle-2">Edit Regular Retail</span>
            </div>
            <v-text-field
              ref="retail_price"
              class="pt-0 mt-0"
              v-model="editItem.retail_price"
              :rules="[isValidPrice, v => !(v < 0) || 'Cannot have negative value.']"
              autofocus
              type="number"
              hide-spin-buttons
              prefix="$">
            </v-text-field>
            <v-card-actions class="pt-0 px-0">
              <v-spacer></v-spacer>
              <v-btn
                text
                small
                @click="cancel">
                Cancel
              </v-btn>
              <v-btn
                small
                color="primary"
                :loading="savingItem"
                :disabled="savingItem || applyingAll || (editItem && editItem.retail_price < 0)"
                @click="save">
                Save
              </v-btn>
              <v-btn
                small
                color="accent"
                :loading="applyingAll"
                :disabled="applyingAll || savingItem || (editItem && editItem.retail_price < 0)"
                @click="openApplyAllDialog">
                Apply All
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </template>
      </template>

       <!-- Accrual Amount -->
       <template v-slot:[`item.billback_allowance`]="{ item }">
        <v-menu
          v-if="(item.billback_allowance != null) && item.accrual_amt"
          open-on-hover
          offset-y
          top
          :close-on-content-click="false">
          <template v-slot:activator="{ on }">
            <span style="display: inline-block; margin-right: 4px">
              {{ item.billback_allowance }}
            </span>
            <v-btn
              class="pa-0 ma-0"
              v-on="on"
              small
              icon>
              <v-icon class="ma-0 pa-0">mdi-information-outline</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Allowance Amount</v-list-item-subtitle>
                  <v-list-item-title>
                    {{ getFormattedAllowance(item.promo_item_group) }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Allowance Type</v-list-item-subtitle>
                  <v-list-item-title>
                    {{ item.promo_item_group.allowance_amt_type }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-subtitle>Accrual Amount</v-list-item-subtitle>
                  <v-list-item-title>
                    {{ `$${$config.formatCurrency(item.accrual_amt)}`}}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <span v-else>{{ item.billback_allowance }}</span>
      </template>

      <!-- AMAP Allowance Menu -->
      <template v-slot:[`item.amap_allowance`]="{ item}">
        <v-menu
          v-if="!isAMAP && Array.isArray(item.item.amap_allowances)"
          :nudge-left="250"
          offset-y
          open-on-hover
          top>
          <template v-slot:activator="{ on }">
            <span class="primary--text" v-on="on" style="cursor: pointer">
              {{ item.amap_allowance_total }}
            </span>
          </template>
          <v-card>
            <v-card-title class="pl-6 primary--text">
              Active AMAP Allowances
            </v-card-title>
            <v-list class="pt-0">
              <v-list-item>
                <v-col cols="5">
                  <v-list-item-subtitle class="font-weight-bold">
                    Promo Name
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="5">
                  <v-list-item-subtitle class="font-weight-bold">
                    Promo Number
                  </v-list-item-subtitle>
                </v-col>
                <v-col cols="2">
                  <v-list-item-subtitle class="font-weight-bold">
                    Amount
                  </v-list-item-subtitle>
                </v-col>
              </v-list-item>
              <v-list-item
                dense
                v-for="amap in item.item.amap_allowances"
                :key="amap.promo_id"
                link
                @click="goToPromo(amap.promo_id)">
                <v-col cols="5">
                  <v-list-item-subtitle>{{ amap.promo_name }}</v-list-item-subtitle>
                </v-col>
                <v-col cols="5">
                  <v-list-item-subtitle>{{ amap.promo_number }}</v-list-item-subtitle>
                </v-col>
                <v-col cols="2">
                  <v-list-item-subtitle v-if="amap.amap_allowance">
                    ${{ $config.formatCurrency(getNumericPrice(amap.amap_allowance)) }}
                  </v-list-item-subtitle>
                </v-col>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <span v-else>{{ item.amap_allowance }}</span>
      </template>

      <!-- Edit Contract Case Cost -->
      <template v-slot:[`item.contract_case_cost`]="{ item }">
        <span v-if="item.contract_case_cost" :style="{'color': item.contract_case_cost === getNumericPrice(item.cost) ? undefined : 'red'}">
          <template v-if="$auth.tenant !== 'alliance-retail-group' || editIsDisabled">
            {{ item.contract_case_cost ? '$' + $config.formatCurrency(item.contract_case_cost) : '' }}
          </template>
          <template v-else>
            <v-menu
              v-model="editingContractCaseCost"
              :close-on-content-click="false"
              :close-on-click="false"
              bottom
              right
              absolute
              nudge-top="-12px"
              nudge-left="16px"
              offset-y
              max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <div class="edit-menu-container"
                  :style="!editIsDisabled ? 'cursor: pointer' : 'cursor: default'"
                  v-on="!editIsDisabled ? on : null"
                  v-bind="attrs"
                  @click="!editIsDisabled ? open(item, 'contract_case_cost') : null">
                  <span>${{ $config.formatCurrency(item.contract_case_cost) }}</span>
                  <v-icon small v-if="!editIsDisabled && typeof item.contract_case_cost === 'number'">mdi-pencil</v-icon>
                </div>
              </template>
              <v-card class="pt-2 px-4" tile flat v-if="editingContractCaseCost && editItem && editItem.id === item.id">
                <div style="margin-top: 8px">
                  <span class="subtitle-2">Edit Contract Case Cost</span>
                </div>
                <v-text-field
                  ref="contract_case_cost"
                  class="pt-0 mt-0"
                  v-model="editItem.contract_case_cost"
                  :rules="[isValidPrice, v => !(v < 0) || 'Cannot have negative value.']"
                  autofocus
                  type="number"
                  hide-spin-buttons
                  prefix="$">
                </v-text-field>
                <v-card-actions class="pt-0 px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    small
                    @click="cancel">
                    Cancel
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    :loading="savingItem"
                    :disabled="savingItem || applyingAll || (editItem && editItem.contract_case_cost < 0)"
                    @click="save">
                    Save
                  </v-btn>
                  <v-btn
                    small
                    color="accent"
                    :loading="applyingAll"
                    :disabled="applyingAll || savingItem || (editItem && editItem.contract_case_cost < 0)"
                    @click="openApplyAllDialog">
                    Apply All
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </template>
        </span>
        <span v-else>-</span>
      </template>

      <!-- Edit Contract AMAP -->
      <template v-slot:[`item.contract_amap`]="{ item }">
        <span v-if="item.contract_amap" :style="{'color': item.contract_amap === getNumericPrice(item.amap_allowance_total) ? undefined : 'red'}">
          <template v-if="$auth.tenant !== 'alliance-retail-group' || editIsDisabled">
            {{ item.contract_amap ? '$' + $config.formatCurrency(item.contract_amap) : '' }}
          </template>
          <template v-else>
            <v-menu
              v-model="editingContractAMAP"
              :close-on-content-click="false"
              :close-on-click="false"
              bottom
              right
              absolute
              nudge-top="-12px"
              nudge-left="16px"
              offset-y
              max-width="300px">
              <template v-slot:activator="{ on, attrs }">
                <div class="edit-menu-container"
                  :style="!editIsDisabled ? 'cursor: pointer' : 'cursor: default'"
                  v-on="!editIsDisabled ? on : null"
                  v-bind="attrs"
                  @click="!editIsDisabled ? open(item, 'contract_amap') : null">
                  <span>${{ $config.formatCurrency(item.contract_amap) }}</span>
                  <v-icon small v-if="!editIsDisabled && typeof item.contract_amap === 'number'">mdi-pencil</v-icon>
                </div>
              </template>
              <v-card class="pt-2 px-4" tile flat v-if="editingContractAMAP && editItem && editItem.id === item.id">
                <div style="margin-top: 8px">
                  <span class="subtitle-2">Edit Contract AMAP</span>
                </div>
                <v-text-field
                  ref="contract_amap"
                  class="pt-0 mt-0"
                  v-model="editItem.contract_amap"
                  :rules="[isValidPrice, v => !(v < 0) || 'Cannot have negative value.']"
                  autofocus
                  type="number"
                  hide-spin-buttons
                  prefix="$">
                </v-text-field>
                <v-card-actions class="pt-0 px-0">
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    small
                    @click="cancel">
                    Cancel
                  </v-btn>
                  <v-btn
                    small
                    color="primary"
                    :loading="savingItem"
                    :disabled="savingItem || applyingAll || (editItem && editItem.contract_amap < 0)"
                    @click="save">
                    Save
                  </v-btn>
                  <v-btn
                    small
                    color="accent"
                    :loading="applyingAll"
                    :disabled="applyingAll || savingItem || (editItem && editItem.contract_amap < 0)"
                    @click="openApplyAllDialog">
                    Apply All
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-menu>
          </template>
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:[`item.contract_net_unit_cost`]="{ item }">
        <span v-if='item.contract_case_cost' :style="{'color': getNumericPrice(item.contract_net_unit_cost) === getNumericPrice(item.net_unit_cost) ? undefined : 'red'}">
          {{ item.contract_net_unit_cost }}
        </span>
        <span v-else>-</span>
      </template>

      <template v-slot:[`item.contract_gross_profit`]="{ item }">
        <span v-if='item.contract_case_cost && item.contract_gross_profit' :style="{'color': item.contract_gross_profit === item.gross_profit ? undefined : 'red'}">
          {{ item.contract_gross_profit }}
        </span>
        <span v-else>-</span>
      </template>

      <!-- Active Allowances -->
      <template v-slot:[`item.net_unit_cost`]="{ item }">
        <template v-if="checkVendorItemAccess">
          <span>{{ item.vendor_user_item ? item.net_unit_cost : '-' }}</span>
        </template>

        <template v-else>
          <v-menu
            v-if="item.has_active_allowances"
            :nudge-left="250"
            offset-y
            open-on-hover
            top>
            <template v-slot:activator="{ on }">
              <span class="primary--text" v-on="on" style="cursor: pointer">
                {{ item.net_unit_cost }}
              </span>
            </template>
            <ActiveAllowances
              :item="item.item"
              :promo_id="promo_id"
              :allowances="item.item.filtered_allowances"
              @goToPromo="goToPromo">
            </ActiveAllowances>
          </v-menu>
          <span v-else>{{ item.net_unit_cost }}</span>
        </template>
      </template>

      <template v-slot:[`item.complex_net_unit_cost`]="{ item }">
        <span v-if="checkVendorItemAccess">
          {{ item.vendor_user_item ? item.complex_net_unit_cost : '-' }}
        </span>
        <span v-else>{{ item.complex_net_unit_cost }}</span>
      </template>

      <template v-slot:[`item.gross_profit`]="{ item }">
        <span v-if="checkVendorItemAccess">
          {{ item.vendor_user_item ? item.gross_profit : '-' }}
        </span>
        <span v-else>{{ item.gross_profit }}</span>
      </template>

      <!-- Related Items -->
      <template v-slot:[`item.related`]="{ item }">
        <v-tooltip class="mx-auto" v-if="item.item.has_item_group && (!checkVendorItemAccess || (checkVendorItemAccess && item.vendor_user_item))" top>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              color="#1976d2"
              class="px-0 mx-0"
              @click.stop="viewRelatedItems(item)">
              <v-icon class="mx-auto">mdi-view-list</v-icon>
            </v-btn>
          </template>
          <span>Related Items</span>
        </v-tooltip>
      </template>

      <!-- Remove Item -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-tooltip top v-if="!editIsDisabled">
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
              small
              color="red"
              @click.stop="removeItem(item)">
              <v-icon>mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <span>Remove</span>
        </v-tooltip>
      </template>
    </v-data-table>

  <!-- Item Add/Search -->
    <ItemSearchModal
      v-if="addItems"
      v-model="addItems"
      :itemGroup="itemGroup"
      :itemGroups="itemGroupList"
      :panel_height="panel_height"
      :promo="promo"
      :promo_type_fields="promo_type_fields"
      :promo_type_constant="promo_type_constant"
      :promoItems="promoItems"
      :uniquePromoItems="uniquePromoItems"
      :item_sources="item_sources"
      :vmc_sources="vmc_sources"
      :readOnlyPromo="editIsDisabled"
      :vendorIds="vendorIds"
      :isAccrualPromo="isAccrualPromo"
      @close="closeItemsModal"
      @updateHistory="$emit('updateHistory')">
    </ItemSearchModal>
    <RelatedItemsModal
      v-if="showRelatedItemsModal"
      v-model="showRelatedItemsModal"
      :promoItem="promoItem"
      :promoItems="promoItems"
      :uniquePromoItems="uniquePromoItems"
      :promoItemGroup="promoItem ? promoItem.promo_item_group : null"
      :item_sources="item_sources"
      :vendorIds="vendorIds"
      :readOnlyPromo="editIsDisabled"
      :promo="promo"
      @close="closeRelatedItemsModal"
      @cancel="showRelatedItemsModal = false">
    </RelatedItemsModal>
    <DeleteItemGroupModal
      @close="deleteModalData.deleting = false"
      v-if="deleteModalData.deleting"
      :groupInfo="deleteModalData"
      @update="deletedPromoItemGroup">
    </DeleteItemGroupModal>

    <!-- Edit Item 'Apply All' Confirmation -->
    <v-dialog
      :value="applyAllDialog"
      width="450"
      @click:outside="closeApplyAllDialog">
      <v-card>
        <v-card-title>
          Confirm Apply All
        </v-card-title>
        <v-card-text>
          {{ applyAllText }}
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="grey darken-1" text @click="closeApplyAllDialog">
            Cancel
          </v-btn>
          <v-btn
            color="success"
            :loading="applyingAll"
            :disabled="applyingAll"
            @click="applyAll">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      :value="showRemoveGroupConfirmDialog"
      width="450"
      @click:outside="showRemoveGroupConfirmDialog = false">
      <v-card>
        <v-card-title>
          Confirm Item Removal
        </v-card-title>
        <v-card-text>
          Remove selected items from Promo?
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="grey darken-1" text @click="showRemoveGroupConfirmDialog = false">
            Cancel
          </v-btn>
          <v-btn
            color="red"
            class="white--text"
            @click="removeSelectedItems">
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <MoveItemsDialog
      v-if="showMoveItemsDialog"
      v-model="showMoveItemsDialog"
      :selectedItems="selectedItems"
      :itemGroups="itemGroupList"
      :promo_type_fields="promo_type_fields"
      :promo_type_constant="promo_type_constant"
      :promo="promo"
      @close="showMoveItemsDialog = false"
      @moveItems="moveItems">
    </MoveItemsDialog>
  </v-card>
</template>
<script>
// API
import PromoItem from '@/axios/promotion-item-endpoint'
import PromoItemGroup from '@/axios/promotion-item-group-endpoint'

// Components
const RelatedItemsModal = () => import('@/components/items/RelatedItemsModal.vue')
const ItemSearchModal = () => import('@/components/items/ItemSearchModal.vue')
const DeleteItemGroupModal = () => import('@/components/items/DeleteItemGroupModal.vue')
const ActiveAllowances = () => import('@/components/items/ActiveAllowances.vue')
const MoveItemsDialog = () => import('@/components/items/MoveItemsDialog.vue')

// Mixins
import { fullWidthTable } from '@/mixins/table'
import { displayAlert } from '@/mixins/alert'
import { formValidation } from '@/mixins/form-validation'
import { utils } from '@/mixins/utils'
import { userAccess } from '@/mixins/user-access'
import { promoItemsProperties } from '@/mixins/promo-items'

// Third Party Helpers
import { cloneDeep } from 'lodash'
export default {
  name: 'items-on-promo',
  data () {
    return {
      deleteModalData: {
        deleting: false,
        groupId: '',
        groupName: ''
      },
      from: 0,
      addItems: false,
      editingCost: false,
      editingRetailPrice: false,
      editingQtyPerCase: false,
      editingContractCaseCost: false,
      editingContractAMAP: false,
      savingItem: false,
      applyingAll: false,
      expanded: [],
      filter: '',
      itemGroup: null,
      editItem: null,
      editKey: '',
      itemGroupList: [],
      items: [],
      promoItems: [],
      uniquePromoItems: [],
      search:'',
      searching: false,
      filterSearch: { key: null, value: null },
      forceActiveAllowance: false,
      valid: true,
      showRelatedItemsModal: false,
      applyAllDialog: false,
      showRemoveGroupConfirmDialog: false,
      showMoveItemsDialog: false,
      promoItem: null,
      headerProps: {
        sortable: false,
        class: 'accent white--text'
      },
      page: 1,
      searchParams: [
        { description: 'Item ID', param: 'item_id_filter' },
        { description: 'UPC', param: 'upc_filter' },
        { description: 'Source', param: 'source_filter' },
        { description: 'Description', param: 'description_filter' },
        { description: 'Vendor', param: 'vendor_filter' },
        { description: 'Item Group Name', param: 'item_group_name_filter' }
      ],
      selectedItems: [],
    }
  },
  components: { DeleteItemGroupModal, ItemSearchModal, RelatedItemsModal, ActiveAllowances, MoveItemsDialog },
  mixins: [
    fullWidthTable,
    displayAlert,
    formValidation,
    utils,
    userAccess,
    promoItemsProperties
  ],
  props: {
    item_sources: Array,
    vmc_sources: Array,
    panel_height: Number,
    promo: Object,
    promo_type_constant: String,
    vendorIds: Array,
    promoPartyIds: Array,
    readOnlyPromo: {
      type: Boolean,
      default: true
    },
    isPromoVendorAdmin: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filter: {
      handler () {
        if (this.filter === null) {
          this.filter = ''
        }
      }
    },
    page: {
      handler(newValue, oldValue) {
        if (oldValue !== newValue) {
          this.initPromoItemList(this.searching)
        }
      }
    },
    item_sources: {
      handler (newValue, oldValue) {
        if (this.$route.query?.id && newValue) {
          if (!oldValue || (JSON.stringify(newValue) !== JSON.stringify(oldValue))) {
            this.initPromoItemList()
          }
        }
      },
      deep: true
    },
    vendorIds: {
      handler (newValue, oldValue) {
        if (this.$route.query?.id && newValue) {
          if (!oldValue || (JSON.stringify(newValue) !== JSON.stringify(oldValue))) {
            this.initPromoItemList()
          }
        }
      },
      deep: true
    },
    panel_height: {
      handler (value) {
        this.nonTableHeight = value
      }
    },
    'promo.audit.updated_on': {
      handler (newVal, oldVal) {
        if (newVal && oldVal) {
          this.initPromoItemList()
          this.initUniquePromoItemList()
          this.initItemGroups()
        }
      }
    },
    '$route.query.id': {
      handler (newValue, oldValue) {
        if (newValue && oldValue) {
          this.updateLists()
        }
      }
    },
    promoItems: {
      handler (newValue, oldValue) {
        if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
          this.$emit('updatePromoItems', newValue)
        }
      }
    }
  },
  computed: {
    anyGroupsExpanded () {
      if (this.filteredItems.length > 0) {
        return Object.keys(this.$refs).some(k => {
          return (this.$refs[k] && this.$refs[k].$attrs['data-open'])
        })
      }
      return false
    },
    uniqueItemCount() {
      return [...new Set(this.uniquePromoItems.map(f => f.item_id))].length
    },
    startHeaders() {
      return [
        { filterable: false, width: this.$auth.tenant === 'alliance-retail-group' ? '.25%' : '1%', show: (this.$auth.tenant !== 'alliance-retail-group' || this.readOnlyPromo) },
        { sortable: false, filterable: false, value: 'included', class: 'accent white--text', show: this.$auth.tenant === 'alliance-retail-group' && !this.readOnlyPromo },
        { text: 'Source', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'item.source_name', width: this.$auth.tenant === 'alliance-retail-group' ? '8%' : undefined },
        { text: 'Item ID', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'item.item_id', width: '5%' },
        { text: this.$auth.tenant === 'alliance-retail-group' ? 'Pack' : 'Qty Per Case', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'item.qty_per_case', width: this.$auth.tenant === 'alliance-retail-group' ? '8%' : undefined },
        { text: this.$auth.tenant === 'alliance-retail-group' ? 'Size' : 'Pack Size', value: 'item.pack_size' },
        { text: 'Description', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'item.description', width: this.$auth.tenant === 'alliance-retail-group' ? '5%' : undefined },
        { text: 'UPC', value: 'item.upc' },
        { text: 'GTIN', value: 'item.gtin', show: (this.$auth.tenant === 'pricechopper') },
        { text: 'Department', value: 'item.department', show: (this.$auth.tenant !== 'alliance-retail-group') },
        { text: 'Case Cost', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'cost', width: this.$auth.tenant === 'alliance-retail-group' ? '5%' : undefined },
        { text: 'Contract Case Cost', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'contract_case_cost', width: this.$auth.tenant === 'alliance-retail-group' ? '5%' : undefined, show: this.showContractValues }
      ].filter(header => (!header.hasOwnProperty('show') || header.show))
    },
    endHeaders() {
      return [
        { text: 'Net Unit Cost', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'net_unit_cost', width: this.$auth.tenant === 'alliance-retail-group' ? '7%' : undefined },
        { text: 'Contract NUC', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'contract_net_unit_cost', width: this.$auth.tenant === 'alliance-retail-group' ? '7%' : undefined, show: this.showContractValues },
        { text: 'Complex NUC', value: 'complex_net_unit_cost', width: '5%', show: this.isComplexPromo && this.$auth.tenant === 'alliance-retail-group' },
        { text: 'Regular Retail', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'retail_price', width: this.$auth.tenant === 'alliance-retail-group' ? '10%' : undefined },
        { text: 'Gross Profit %', value: 'gross_profit' },
        { text: 'Contract GP%', value: 'contract_gross_profit', show: this.showContractValues },
        { text: 'Related Items', value: 'related', filterable: 'false', align: 'center' },
        { text: '', value: 'actions', filterable: false, width: '2%' },
      ].filter(header => (!header.hasOwnProperty('show') || header.show))
    },
    promoTypeHeaders () {
    return [
        // {text: 'Amount Off', sortable: false, value: 'amount_off'},
        { text: 'Billback Allowance', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'billback_allowance' },
        { text: 'AMAP Allowance', value: 'amap_allowance', show: !this.isVendorAccrualPromo },
        { text: 'Contract AMAP', value: 'contract_amap', show: this.showContractValues },
        { text: 'Early Buy Allowance', value: 'early_buy_allowance', show: ((this.$auth.tenant === 'awg') || this.isEBA)  },
        { text: this.scanAllowanceLabel, sortable: this.$auth.tenant === 'alliance-retail-group', value: 'rebate_amount', width: this.$auth.tenant === 'alliance-retail-group' ? '10%' : undefined },
        { text: (this.isComplexPromo && this.$auth.tenant === 'alliance-retail-group') ? 'Base Ad Promo Price' : 'Promotion Price', sortable: this.$auth.tenant === 'alliance-retail-group', value: 'promotion_price', width: this.$auth.tenant === 'alliance-retail-group' ? '15%' : undefined, show: !this.isVendorAccrualPromo },
        { text: 'Complex Promo Price', sortable: true, value: 'complex_promo_price', show: this.isComplexPromo && this.$auth.tenant === 'alliance-retail-group', width: '15%' },
        { text: 'Variance', value: 'variance' },
        { text: 'Buy Item', value: 'buy_item' },
        { text: 'Get Item', value: 'get_item' },
        { text: 'Quantity', value: 'qty' },
      ].filter(header => (!header.hasOwnProperty('show') || header.show))
    },
    scanAllowanceLabel() {
      if (['BUY_X_SAVE_$Y', 'BUY_X_GET_X'].includes(this.promo_type_constant)) {
        return this.complexAllowanceLabel
      }
      return this.isVendorAccrualScan ? 'Percentage' : 'Scan Allowance'
    },
    existingPromo () {
      return (this.$route.query.id) ?? false
    },
    headers() {
      const finalHeaders = [...this.startHeaders, ...this.currentTypeHeaders, ...this.endHeaders]
      return finalHeaders.map(header => ({ ...this.headerProps, ...header }))
    },
    currentTypeHeaders() {
      return this.promoTypeHeaders.filter(header => {
        return this.promo_type_fields.includes(header.value)
      })
    },
    id () {
      return (this.$route.query.id) ?? this.promo_id
    },
    noDataText () {
      return (this.$route.query?.id)
        ? 'Please add items to the promotion'
        : 'Please finish creating promotion to add items'
    },
    promo_id (){
      return this.promo.id
    },
    promo_type_fields () {
      let fields = []
      switch (this.promo_type_constant) {
        case ('BUY_X_GET_X'):
          fields = [
            'buy_item',
            'get_item',
            'qty',
            'rebate_amount',
          ]
          if (['pricechopper', 'alliance-retail-group'].includes(this.tenant)) {
            fields.push('promotion_price')
            if (this.tenant === 'alliance-retail-group') fields.push('complex_promo_price', 'amap_allowance', 'contract_amap')
          }
          if (this.promo.enforce_compliance && !this.tenantIgnoresCompliance) fields.push('variance')
          return fields
        case ('BUY_X_SAVE_$Y'):
          fields = [
            'qty',
            'rebate_amount'
          ]
          if (['pricechopper', 'alliance-retail-group'].includes(this.tenant)) {
            fields.push('promotion_price')
            if (this.tenant === 'alliance-retail-group') fields.push('complex_promo_price', 'amap_allowance', 'contract_amap')
          }
          if (this.promo.enforce_compliance && !this.tenantIgnoresCompliance) fields.push('variance')
          return fields
        case ('AMOUNT_OFF'):
          fields = [
            'amount_off',
            'promotion_price',
            'rebate_amount',
            'retail_price'
          ]
          if (this.isNonAllowancePromo) {
            fields = ['promotion_price', 'retail_price']
          }
          if (this.promo.enforce_compliance && !this.tenantIgnoresCompliance) fields.push('variance')
          if (this.tenant === 'alliance-retail-group') fields.push('amap_allowance', 'contract_amap')
          return fields
        case ('PERCENT_OFF'):
          fields = [
            'percent_off',
            'promotion_price',
            'rebate_amount',
            'retail_price'
          ]
          if (this.promo.enforce_compliance && !this.tenantIgnoresCompliance) fields.push('variance')
          return fields
        case ('BILLBACK'):
          if (this.isAMAP) {
            fields = ['amap_allowance', 'promotion_price']
          } else if (this.isEBA) {
            fields = ['early_buy_allowance', 'promotion_price']
          } else if (this.isAccrualPromo) {
            fields = ['billback_allowance', 'promotion_price']
            if (this.tenant === 'alliance-retail-group') {
              fields.push('amap_allowance', 'contract_amap')
            }
          } else if (this.isNonAllowancePromo) {
            fields = ['promotion_price']
            if (this.tenant === 'alliance-retail-group') {
              fields.push('amap_allowance', 'contract_amap')
            }
          } else {
            fields = [
                'billback_allowance',
                'amap_allowance',
                'early_buy_allowance',
                'promotion_price'
              ]
            if (this.tenant === 'alliance-retail-group') fields.push('contract_amap')
          }
          return fields
        default:
          return fields
      }
    },
    isMergedPromo () {
      const mergedFromIds = this.promo?.merged_from_promo_ids
      return Array.isArray(mergedFromIds) && (mergedFromIds.length > 0)
    },
    isActiveAllowanceTenant () {
      return ['pricechopper', 'alliance-retail-group'].includes(this.$auth.tenant)
    },
    disableActiveAllowance () {
      return this.isMergedPromo || this.promo.billing_mode.constant === 'VENDOR_ACCRUAL'
    },
    getActiveAllowances () {
      return this.isActiveAllowanceTenant && (!this.disableActiveAllowance || this.forceActiveAllowance)
    },
    usePromoItemCost () {
      return this.tenant === 'pricechopper' && this.promo?.promo_category?.name.toLowerCase().includes('dsd')
    },
    usePromoItemQtyPerCase () {
      return this.tenant === 'pricechopper' && this.promo?.promo_category?.name.toLowerCase().includes('dsd')
    },
    allowanceFields () {
      return this.promo?.promo_category?.scan_promotion
        ? ['rebate_amount']
        : ['billback_allowance', 'amap_allowance', 'early_buy_allowance', 'amap_allowance_total']
    },
    applyAllText () {
      if (this.applyAllDialog) {
        const newValue = this.editItem?.[this.editKey]
        if (newValue == null || newValue === '') {
          return `Clear edited value for all items in the group?`
        }
        const formattedValue = this.getFormattedPrice(newValue)
        if (this.editingCost) {
          return `Apply case cost of ${formattedValue} to all items in the group?`
        }
        if (this.editingQtyPerCase) {
          return `Apply ${this.$auth.tenant === 'alliance-retail-group' ? 'pack' : 'qty per case'} of ${newValue} to all items in the group?`
        }
        if (this.editingRetailPrice) {
          return `Apply retail price of ${formattedValue} to all items in the group?`
        }
        if (this.editingContractCaseCost) {
          return `Apply contract case cost of ${formattedValue} to all items in the group?`
        }
        if (this.editingContractAMAP) {
          return `Apply contract AMAP value of ${formattedValue} to all items in the group?`
        }
      }
      return null
    },
    effectiveFutureCostDate () {
      return ['alliance-retail-group', 'pricechopper'].includes(this.tenant) 
        ? this.promo.start_dt 
        : this.promo.end_dt
    },
    checkVendorItemAccess () {
      return (this.$auth.tenant === 'alliance-retail-group') && !this.isPromoVendorAdmin
    },
    showContractValues () {
      return this.tenant === 'alliance-retail-group' && !this.isAMAP && !this.isEBA && !this.isVendorAccrualPromo
    },
    checkNetUnitAllowances () {
      const isNotDSD = this.promo?.promo_category?.name.toLowerCase() !== 'dsd off invoice'
      const allowanceBillingMode = ['AD', 'TPR', 'EDLC'].includes(this.promo.billing_mode.constant)
      return this.$auth.tenant === 'alliance-retail-group' && !this.isComplexPromo && isNotDSD && allowanceBillingMode
    },
    sourceSelections () {
      return this.getPossibleSources()
    },
    showSourceFilter () {
      return this.filterSearch.key?.param === 'source_filter'
    },
    filterValueIsEmpty () {
      return this.filterSearch.value === null || this.filterSearch.value === undefined || this.filterSearch.value === ''
    },
    filteredItems () {
      if (this.filter !== '') {
        const filter = this.filter.toLowerCase()
        const filteredItems = this.items.filter(i => (i.item?.source_name?.toLowerCase().includes(filter) || i.item?.description?.toLowerCase().includes(filter) || i.item?.item_id?.toLowerCase().includes(filter) || i.item?.upc?.includes(this.filter) || i.promo_item_group?.name?.toLowerCase().includes(filter)))
        return filteredItems
      }
      return this.items
    },
    editIsDisabled() {
      return !(this.promo?.status?.status?.constant === 'INCLUDED_IN_MERGE' && this.userRoles.some(role => ['promo.admin', 'ipro-admin', 'arg-admin', 'arg-category-manager'].includes(role))) && this.readOnlyPromo
    },
  },
  created () {
    this.nonTableHeight = this.panel_height
    this.initPromoItemList()
    this.initUniquePromoItemList()
    this.initItemGroups()
  },
  methods: {
    closeAll () {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    openAll () {
      Object.keys(this.$refs).forEach(k => {
        if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
          this.$refs[k].$el.click()
        }
      })
    },
    handleAllSelection(bool) {
      this.selectedItems = bool ? [...this.filteredItems] : [];
      
      this.filteredItems.forEach(item => {
        item.selected = bool;
        this.itemSelected(bool, item);
      });
    },
    itemSelected (value, item) {
      if (value === true) {
        if (!this.isSelected(item.id)) {
          this.selectedItems.push(item)
        }
      } else {
        const index = this.selectedItems.findIndex(i => {
          return (i.id === item.id)
        })
        if (index > -1) this.selectedItems.splice(index, 1)
      }
    },
    isSelected(id) {
      return this.selectedItems.map(i => i.id).includes(id)
    },
    handleRemoveGroupConfirmDialog() {
      this.showRemoveGroupConfirmDialog = true
    },
    async removeSelectedItems () {
      this.loading = true
      const idsToRemove = this.selectedItems.map(s => s.id)
      await PromoItem.deleteGroup(idsToRemove)
        .catch(err => {
         this.handleError(err)
        }).finally(() => {
          this.updateLists()
          this.showRemoveGroupConfirmDialog = false
          this.loading = false
          this.selectedItems = []
        })
    },
    async moveItems (selectedGroup, newGroup) {
      this.loading = true
      const idsToRemove = this.selectedItems.map(s => s.id)
      let promoItemGroupId = selectedGroup
      if (selectedGroup === 'new_group' && newGroup) {
        const response = await PromoItemGroup.post(newGroup).catch((err) => {
          this.handleError(err)
        })
        promoItemGroupId = response.data.id
      }
      await PromoItemGroup.movePromoItems(idsToRemove, promoItemGroupId)
        .catch(err => {
         this.handleError(err)
        }).finally(() => {
          this.updateLists()
          this.showMoveItemsDialog = false
          this.selectedItems = []
          this.loading = false
        })
    },
    goToPromo(promo_id) {
      let route = this.$router.resolve({ path: "/promo", query: { id: promo_id } })
      window.open(route.href)
    },
    clearFilter() {
      this.filterSearch.key = null
      this.filterSearch.value = null
      this.page = 1
      this.searching = false
      this.initPromoItemList()
    },
    getPossibleSources() {
      const sources = new Map()
      for (const i of this.uniquePromoItems) {
        let entry = sources.get(i.source)
        if (!entry) {
          entry = { id: i.source, name: i.source_name, items: new Set() }
          sources.set(i.source, entry)
        }
        entry.items.add(i.item_id)
      }
      return [...sources.values()].map(({ id, name, items }) => ({
        id,
        name,
        count: items.size,
      }))
    },
    closeItemsModal (updateItems = false) {
      this.addItems = false
      this.itemGroup = null
      if (updateItems) this.updateLists()
    },
    closeRelatedItemsModal (updateItems = false) {
      this.showRelatedItemsModal = false
      if (updateItems) {
        this.$emit('updateHistory')
        this.updateLists()
      }
    },
    open (item, key) {
      this.editKey = key
      this.editItem = cloneDeep(item)
      const numericValue = this.getNumericPrice(item[key])
      const editValue = (numericValue === 0) ? null : numericValue.toFixed(2)
      this.editItem[key] = editValue
    },
    openQtyPerCase (item) {
      this.editKey = 'qty_per_case'
      this.editItem = cloneDeep(item)
      let numericValue
      if (this.usePromoItemQtyPerCase && item['promo_item_qty_per_case']) {
        numericValue = item['promo_item_qty_per_case']
      } else {
        numericValue = item.item['qty_per_case']
      }
      this.editItem['qty_per_case'] = numericValue
    },
    save () {
      const valid = this.$refs[this.editKey].validate()
      if (valid) {
        return this.updateItem(this.editItem)
      }
    },
    cancel () {
      this.editItem = null
      this.editingCost = false
      this.editingRetailPrice = false
      this.editingQtyPerCase = false
      this.editingContractCaseCost = false
      this.editingContractAMAP = false
      this.editKey = ''
    },
    openApplyAllDialog () {
      const valid = this.$refs[this.editKey].validate()
      if (valid) {
        this.applyAllDialog = true
      }
    },
    closeApplyAllDialog () {
      this.applyAllDialog = false
    },
    async applyAll () {
      const groupItems = this.items.filter(item => item.promo_item_group.id === this.editItem.promo_item_group.id)
      this.applyingAll = true
      try {
        const promises = groupItems.map(item => {
          const promoItem = cloneDeep(this.promoItems.find(pi => pi.id === item.id))
          promoItem[this.editKey] = this.editItem[this.editKey]
          return this.updateItem(promoItem, true)
        })
        const { rejected } = await this.getAllSettled(promises, true)
        if (rejected.length > 0) throw rejected
        this.cancel()
        this.updateLists()
        this.$emit('updateHistory')
        this.closeApplyAllDialog()
      } catch (err) {
        this.handleError(err)
      } finally {
        this.applyingAll = false
      }
    },
    deletedPromoItemGroup (group, groupName) {
      if (group) {
        this.deleteModalData.deleting = true
        this.deleteModalData.groupId = group
        this.deleteModalData.groupName = groupName
      } else {
        this.updateLists()
        this.$emit('updateHistory')
      }
    },
    async initPromoItemList (search = false) {
      this.loading = true
      const promoId = this.$route.query.id
      let items = []
      let totalCount = 0
      let searchPayload = {
        promo_id: promoId,
        offset: (this.page - 1) * 200,
        limit: 200,
        paging: this.$auth.tenant !== 'alliance-retail-group',
        check_allowances: this.getActiveAllowances
      }
      if (search && this.filterSearch.key && !this.filterValueIsEmpty) {
        searchPayload[this.filterSearch.key.param] = this.filterSearch.value
      }
      try {
        const res = await PromoItem.getItemsByPromo(searchPayload)
        if (this.$auth.tenant === 'alliance-retail-group') {
          this.promoItems = res?.data?.items || []
          if (res?.data?.items?.length > 0) {
            totalCount = res.data.total_count 
            if (!search) this.$emit('updateTotalItems', totalCount)
            items = res.data.items.map(promoItem => this.formatPromoItem(promoItem))
          }
          this.serverItemsLength = totalCount
        }
        else {
          this.promoItems = res?.data || []
          if (res?.data?.length > 0) {
            items = res.data.map(promoItem => this.formatPromoItem(promoItem))
          }
        }
        this.items = items
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    promoItemSearch () {
      this.searching = true
      if (this.page === 1) {
        // Already on page 1, the page watcher won't fire, so fetch directly.
        this.initPromoItemList(true)
      } else {
        // Resetting the page triggers the page watcher, which owns the fetch.
        this.page = 1
      }
    },
    async initUniquePromoItemList () {
      const promoId = this.$route.query.id
      try {
        const res = await PromoItem.getUniqueItemsByPromo(promoId)
        this.uniquePromoItems = res?.data || []
      } catch (err) {
        this.handleError(err)
      }
    },
    getFilteredAMAPs (item) {
      const filtered = item.amap_allowances.filter(amap => {
        // not ideal but only way to distinguish these promos currently
        return amap?.promo_name?.toLowerCase()?.includes('associated wholesale grocers')
      })
      return (filtered.length > 0) ? filtered : null
    },
    getFormattedAllowance (group) {
      const { allowance_amt, allowance_amt_type } = group
      if (allowance_amt_type?.toLowerCase() === 'percent') {
        return `${allowance_amt}%`
      } else if (allowance_amt_type?.toLowerCase() === 'per pound') {
        return `${allowance_amt} lbs`
      }
      return `$${this.$config.formatCurrency(allowance_amt)}`
    },
    viewRelatedItems (item) {
      this.promoItem = item
      this.showRelatedItemsModal = true
    },
    async addItem (item, include = true, itemGroupId = null) {
      let newItem = cloneDeep(item)
      const itemData = {
        promo_item_group_id: itemGroupId || this.itemGroup.id,
        item_id: newItem.item_id,
        include_item: include,
        source: newItem.source
      }
      await PromoItem.post(itemData).then(() => {
        if (this.bulkSearchPayload) this.updateLists()
        this.$emit('updateHistory')
      })
        .catch(err => {
          this.handleError(err)
        })
    },
    async updateItem (promoItem, applyAll = false) {
      const { item, promo_item_group } = promoItem
      let payload = {
        id: promoItem.id,
        promo_item_group_id: promo_item_group.id,
        item_id: item.item_id,
        include_item: promoItem.include_item,
        variance: promoItem.variance ? this.getNumericPrice(promoItem.variance) : null,
        source: item.source,
        retail_price: promoItem.retail_price ? this.getNumericPrice(promoItem.retail_price) : null,
        contract_case_cost: promoItem.contract_case_cost ? this.getNumericPrice(promoItem.contract_case_cost) : null,
        contract_amap: promoItem.contract_amap ? this.getNumericPrice(promoItem.contract_amap) : null
      }
      if (this.usePromoItemCost) {
        payload = {...payload, cost: promoItem.cost ? this.getNumericPrice(promoItem.cost) : null }
      }
      if (this.usePromoItemQtyPerCase) {
        const qty = promoItem.qty_per_case ? promoItem.qty_per_case : promoItem.promo_item_qty_per_case
        payload = {...payload, qty_per_case: Number(qty) }
      }
      this.savingItem = true
      try {
        const res = await PromoItem.put(promoItem.id, payload)
        if (res?.data?.updated === 1 && !applyAll) {
          this.editingCost = false
          this.editingRetailPrice = false
          this.editingQtyPerCase = false
          this.editingContractCaseCost = false
          this.editingContractAMAP = false
          this.editItem = null
          this.updateLists()
          this.$emit('updateHistory')
        }
      } catch (err) {
        this.handleError(err)
      } finally {
        this.savingItem = false
      }
    },
    async removeItem (item) {
      try {
        await PromoItem.delete(item.id)
        this.$emit('updateHistory')
        this.updateLists()
      } catch (err) {
        this.handleError(err)
      }
    },
    async initItemGroups () {
      let itemGroups = []
      try {
        let offset = 0
        const limit = 200
        const res = await PromoItemGroup.getItemGroupsByPromo(this.$route.query.id, limit, offset)
        itemGroups = res.data.map(group => this.getFormattedGroup(group, this.isAccrualPromo))
        if (itemGroups.length > 0) {
          offset += limit
          while (offset === itemGroups.length) {
            const offsetRes = await PromoItemGroup.getItemGroupsByPromo(this.$route.query.id, limit, offset)
            itemGroups = itemGroups.concat(offsetRes.data.map(group => this.getFormattedGroup(group, this.isAccrualPromo)))
            offset += limit
          }
        }
      } catch (err) {
        this.handleError(err)
      }
      this.itemGroupList = itemGroups
    },
    groupOverridingPromo (group) {
      const override = this.promo_type_fields.some(field => {
        const groupValue = group[`${field}`]
        const promoValue = this.promo[`${field}`]
        return (groupValue != null && groupValue != promoValue)
      })
      return override
    },
    createNewGroup () {
      this.itemGroup = null
      this.addItems = true
    },
    editGroup(groupId) {
      this.itemGroup = this.itemGroupList.find(group => group.id === groupId)
      this.addItems = true
    },
    updateLists () {
      this.initPromoItemList()
      this.initUniquePromoItemList()
      this.initItemGroups()
    },
    toggleAll () {
      const keys = Object.keys(this.$refs)
      for (const k of keys) {
        if (this.$refs[k]) {
          // this.handleGroupToggle(k)
        }
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.group-actions-container {
  display: grid;
  grid-auto-columns: auto;
  grid-auto-flow: column;
  justify-content: flex-end;
  padding: 5px 0;
  grid-column-gap: 4px;
}

.edit-menu-container {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  grid-column-gap: 10px;
  position: relative;
}

.sticky {
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: transparent;
}
</style>